var styles = {"root":"ReferralInstructionSteps-module_root__cBIZV","grid":"ReferralInstructionSteps-module_grid__1dR8P","gridDesktop":"ReferralInstructionSteps-module_gridDesktop__1GZkN","gridMobile":"ReferralInstructionSteps-module_gridMobile__25PYu","item":"ReferralInstructionSteps-module_item__1Bd4A"};

export { styles as default };
//# sourceMappingURL=ReferralInstructionSteps.module.css.js.map
